import { useCashback } from '@/contexts/cashback';
import { useLayout } from '@/contexts/layout';
import { useReservationBar } from 'contexts/reservationBar';
import { useRouter } from 'next/router';
import CurrentIcon from 'public/icons/progress-step-current.svg';
import CheckIcon2 from 'public/icons/progress-step-done.svg';
import ToDoIcon from 'public/icons/progress-step-todo.svg';
import styles from 'styles/ReservationBar.module.css';

export default function ReservationBar() {
  const {
    reservationBar: { step },
  } = useReservationBar();
  const { isPaymentResumeOpen } = useLayout();
  const { disableCashbackMode, ignoreNextUpdateRef } = useCashback();

  const router = useRouter();

  // Adjust the step based on the current route
  const currentStep = router.pathname.startsWith('/confirmacao') || router.pathname.startsWith('/reserva') ? 6 : step;

  const objectToQuery = (object: any): string => {
    return Object.keys(object).map(key => {
      if (key === 'extras') {
        if (Array.isArray(object.extras)) {
          return object.extras.map((extra: any) => `extras=${encodeURIComponent(extra)}`).join('&');
        }
      }

      return `${key}=${encodeURIComponent(object[key])}`;
    }).join('&');
  }

  const stepsData = [
    { label: 'Local e Data', query: '/', minStep: 1 },
    { label: 'Veículo', query: '/veiculos', minStep: 2 },
    { label: 'Proteção e Opcionais', query: '/extras', minStep: 3 },
    { label: 'Condutor', query: '/condutor', minStep: 4 },
    { label: 'Pagamento', query: '/pagamento', minStep: 5 },
    { label: 'Confirmação', query: '/', minStep: 6 },
  ]

  const ancorProgressBar = (query: any) => {
    router.push(`${query}?${objectToQuery(router.query)}`)
  }

  const navigate = async (query: string) => {
    let queryParams = router.query;

    if (router.query.cashback) {
      ignoreNextUpdateRef.current = true;

      const cleanQuery = await disableCashbackMode();

      if (cleanQuery) {
        queryParams = cleanQuery;
      }
    }

    const queryString = objectToQuery(queryParams);
    router.push(`${query}?${queryString}`)
  }

  if (isPaymentResumeOpen) {
    return null;
  }

  return (
    <div className={styles.reservationBar}>
      {/* <div className={styles.reservationBar__content_mobile}>
        <h3 className={styles.content__title}>{title}</h3>
        <ReservationBarProgress step={currentStep} progress={progress} max={max} />
      </div> */}
      <div className={styles.reservationBar__content_desktop}>
        <div className={styles.reservationBar__steps}>
          {stepsData.map(({ label, query, minStep }, index) => (
            <div
              key={index}
              className={`
                          ${styles.reservationBar__step} 
                          ${currentStep > minStep && styles.reservationBar__step_active}
                          ${currentStep == minStep && styles.reservationBar__step_left}`}
            >
              <h3
                className={`
                            ${styles.reservationBar__step__title} 
                            ${currentStep >= minStep && styles.active} 
                            ${currentStep > minStep && styles.hasValue}`}
              >
                {label}
              </h3>
              {currentStep > minStep && currentStep !== 6 && (
                <>
                  <span className={styles.reservationBar__step__subtitle} onClick={() => navigate(query)}>Editar</span>
                </>
              )}
              {currentStep > minStep && <CheckIcon2 onClick={() => ancorProgressBar(query)} className={styles.icon} />}
              {currentStep === minStep && <CurrentIcon className={styles.icon} />}
              {currentStep < minStep && <ToDoIcon className={`${styles.icon} ${styles.toDo__icon}`} />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
